jQuery(function($) {

  if(typeof cartMoneyFormat == 'undefined') {
    var cartMoneyFormat = '"$"';
  }

  ajaxCart.init({
    formSelector: '.js-plant-pod-cart-form',
    cartContainer: '#CartContainer',
    addToCartSelector: '.js-plant-pod-cart-btn',
    cartCountSelector: '#CartCount',
    cartCostSelector: '#CartCost',
    moneyFormat: cartMoneyFormat
  });

  var colorUpdate = function() {

    var $sg3Select = $('#js-sg3-color-select');
    var $sg3Img = $('#js-sg3-image');
    var sg3Val = $sg3Select.val();

    var $sg9Select = $('#js-sg9-color-select');
    var $sg9Img = $('#js-sg9-image');
    var sg9Val = $sg9Select.val();

    if (sg3Val === '38148692097' || sg3Val === '33068920911' || sg3Val === '47820374220') {
      $src = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG3-grey-angle-basils-web_400w.jpg?v=126818541318597475271612349976";
      $srcset = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG3-grey-angle-basils-web_400w.jpg?v=126818541318597475271612349976 400w, //www.clickandgrow.com/cdn/shop/t/160/assets/SG3-grey-angle-basils-web_800w.jpg?v=65960782728932535491612349976 800w";
    } else if (sg3Val === '38148692161' || sg3Val === '33068920975' || sg3Val === '47820374284') {
      $src = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG3-beige-angle-basils-web_400w.jpg?v=85461391201704147601612349973";
      $srcset = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG3-beige-angle-basils-web_400w.jpg?v=85461391201704147601612349973 400w, //www.clickandgrow.com/cdn/shop/t/160/assets/SG3-beige-angle-basils-web_800w.jpg?v=11081124256424242361612349974 800w";
    } else if (sg3Val === '31150912241699' || sg3Val === '31170443837530' || sg3Val === '31121506173039') {
      $src = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG3-gold-angle-basils-web_400w.jpg?v=86392283199927192481612349975";
      $srcset = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG3-gold-angle-basils-web_400w.jpg?v=86392283199927192481612349975 400w, //www.clickandgrow.com/cdn/shop/t/160/assets/SG3-gold-angle-basils-web_800w.jpg?v=75114587289524666821612349975 800w";
    } else if (sg3Val === '32364935217187' || sg3Val === '32568601772122' || sg3Val === '32009118744687') {
      $src = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG3-limited-edition-angle-basils-web_400w.jpg?v=165698937646418415021612349977";
      $srcset = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG3-limited-edition-angle-basils-web_400w.jpg?v=165698937646418415021612349977 400w, //www.clickandgrow.com/cdn/shop/t/160/assets/SG3-limited-edition-angle-basils-web_800w.jpg?v=113184148304003734211612349978 800w";
    } else {
      $src = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG3-white-angle-basils-web_400w.jpg?v=30422450508392544911612349979";
      $srcset = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG3-white-angle-basils-web_400w.jpg?v=30422450508392544911612349979 400w, //www.clickandgrow.com/cdn/shop/t/160/assets/SG3-white-angle-basils-web_640w.jpg?v=170746212376609289731612349979 640w";
    }
    $sg3Img.attr('src', $src);
    $sg3Img.attr('srcset', $srcset);

    if (sg9Val === '38148698049' || sg9Val === '33346859535' || sg9Val === '47820369868') {
      $src = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG9-grey-side-starterkit_400w.jpg?v=10928208091409266601612349986";
      $srcset = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG9-grey-side-starterkit_400w.jpg?v=10928208091409266601612349986 400w, //www.clickandgrow.com/cdn/shop/t/160/assets/SG9-grey-side-starterkit_800w.jpg?v=94028540016142512051612349986 800w";
    } else if (sg9Val === '38148698113' || sg9Val === '33346859599' || sg9Val === '47820369996') {
      $src = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG9-beige-side-starterkit_400w.jpg?v=26740252992121991371612349982";
      $srcset = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG9-beige-side-starterkit_400w.jpg?v=26740252992121991371612349982 400w, //www.clickandgrow.com/cdn/shop/t/160/assets/SG9-beige-side-starterkit_800w.jpg?v=81918559843300826611612349983 800w";
    } else if (sg9Val === '31151046590499' || sg9Val === '31170512617562' || sg9Val === '31121510957167') {
      $src = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG9-gold-side-starterkit_400w.jpg?v=167413925165545156271612349984";
      $srcset = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG9-gold-side-starterkit_400w.jpg?v=167413925165545156271612349984 400w, //www.clickandgrow.com/cdn/shop/t/160/assets/SG9-gold-side-starterkit_800w.jpg?v=9914581769692430511612349984 800w";
    } else {
      $src = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG9-white-side-starterkit_400w.jpg?v=40835883959273461101612349993";
      $srcset = "//www.clickandgrow.com/cdn/shop/t/160/assets/SG9-white-side-starterkit_400w.jpg?v=40835883959273461101612349993 400w, //www.clickandgrow.com/cdn/shop/t/160/assets/SG9-white-side-starterkit_640w.jpg?v=33383404229964845581612349994 640w";
    }
    $sg9Img.attr('src', $src);
    $sg9Img.attr('srcset', $srcset);

  }

  colorUpdate();

  $('#js-sg3-color-select, #js-sg9-color-select').on('change', function() {
    colorUpdate();
  });

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top + 100;
    var elementBottom = elementTop + $(this).outerHeight() - 200;

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  var autoplayVideo = function() {
    var iframe = document.getElementById('js-autoplay-video');
    if(typeof(iframe) != 'undefined' && iframe != null) {
      var player = new Vimeo.Player(iframe);
      player.setVolume(0);

      $(window).on('resize scroll', function() {
        if ($('#js-autoplay-video').isInViewport()) {
          player.play();
        } else {
          player.pause();
        }
      });
    }
  }

  autoplayVideo();

  $(function() {

    $('#js-insta-slider').slick({
      centerMode: true,
      lazyLoad: 'progressive',
      prevArrow: '#js-slider-prev-btn',
      nextArrow: '#js-slider-next-btn',
      variableWidth: true,
      rows: 0
    });

  })

  $(document).on('change', '.js-promo-product-select', function() {
    var value = $(this).find(":selected").attr('data-price');
    $(this).parent().siblings('.js-promo-product-price').text(value);
  });

});

if (typeof runStockFilter !== 'undefined' && runStockFilter == true) {

  var stockCheck = function() {

    var variantSelectBtn = function() {
      $('.js-promo-product-select').each(function() {

        var $this = $(this);
        var $enabledOptions = $this.find('option:enabled');
        var listValue = $enabledOptions.length;
        var $selectedOption = $this.find('option:selected');

        if (listValue == 0) {
          $container = $this.closest('.js-plant-pod-cart-form');
          $container.siblings('.js-promo-product-price').hide();
          $container.html('<span style="font-weight: 600;">Sold out.</span>');
        } else {
          if ($selectedOption.is(':disabled')) {
            $selectedOption = $enabledOptions.first();
            var selectedPrice = $selectedOption.attr('data-price');
            var selectedValue = $selectedOption.val();
            $this.val(selectedValue);
            var value = $this.find(":selected").attr('data-price');
            $this.closest('.js-plant-pod-cart-form').siblings('.js-promo-product-price').text(selectedPrice);
            $this.closest('.js-plant-pod-cart-form').find('.js-promo-product-price').text(selectedPrice);
          }
        }

      });
    }

    if (typeof outOfStockList !== 'undefined' && stockListLoaded == true) {

      for (var i = 0; i < outOfStockList.length; i++) {
        var product_sku = outOfStockList[i];
        $('option[data-sku='+product_sku+']').attr('disabled', 'disabled').hide();
      }

      variantSelectBtn();

    } else {

      var reCheck = setInterval(function() {

        if (typeof outOfStockList !== 'undefined' && stockListLoaded == true) {

          for (var i = 0; i < outOfStockList.length; i++) {
            var product_sku = outOfStockList[i];
            $('option[data-sku='+product_sku+']').attr('disabled', 'disabled').hide();
          }

          variantSelectBtn();
          clearInterval(reCheck);

        }

      }, 500);

    }
  }

  stockCheck();

}
